/* Carusel hero Atelier — rotire auto, sageti, puncte, swipe pe touch.
   Fara librarie. Se opreste la hover / focus / cand tab-ul e inactiv. */
(function () {
  var root = document.querySelector('[data-atelier-hero]');
  if (!root) return;

  var track = root.querySelector('[data-atelier-hero-track]');
  var count = parseInt(root.dataset.count || '1', 10);
  if (!track || count < 2) return;

  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-atelier-hero-dot]'));
  var prevBtn = root.querySelector('[data-atelier-hero-prev]');
  var nextBtn = root.querySelector('[data-atelier-hero-next]');
  var autoplayMs = (parseInt(root.dataset.autoplay || '0', 10) || 0) * 1000;

  var index = 0;
  var timer = null;

  function render(anim) {
    if (!anim) track.classList.add('no-anim');
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
    if (!anim) {
      // forteaza reflow apoi reactiveaza tranzitia
      void track.offsetWidth;
      track.classList.remove('no-anim');
    }
    dots.forEach(function (d, i) {
      if (i === index) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  function go(to, anim) {
    index = (to + count) % count;
    render(anim !== false);
  }
  function next() { go(index + 1); }
  function prev() { go(index - 1); }

  function start() {
    stop();
    if (autoplayMs > 0) timer = setInterval(next, autoplayMs);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      go(parseInt(d.dataset.atelierHeroDot, 10));
      start();
    });
  });

  // pauza la interactiune
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  // swipe pe touch
  var x0 = null;
  track.addEventListener('touchstart', function (e) {
    x0 = e.touches[0].clientX;
    stop();
  }, { passive: true });
  track.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
    x0 = null;
    start();
  });

  // tastatura pe container
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { next(); start(); }
    if (e.key === 'ArrowLeft') { prev(); start(); }
  });

  render(false);
  start();
})();
